import React from 'react';
import { ColumnsType } from 'antd/lib/table';
import { getI18n } from 'react-i18next';
import TableHeader from '~/pages/agent/components/agent/tableElements/TableHeader';
import { CellText } from '~/pages/agent/components/agent/tableElements/cells/CellText';

function useAdGroupNameCell(visibleColumns: any) {
  if (!visibleColumns.includes('adGroupName')) {
    return null;
  }
  return {
    title: <TableHeader title={getI18n().t('Ad Group Name', { ns: 'sales' })} />,
    dataIndex: ['adGroupName'],
    key: 'adGroupName',
    render: (adGroupName: any) => <CellText>{adGroupName}</CellText>,
    width: 150,
  };
}

export default useAdGroupNameCell;
